import { OrderDetailsView } from '@nexelem/graphne-api';

export const getSalesOrderIds = (orders?: OrderDetailsView[]) =>
  orders?.map(({ supplierOrderNumber, positionInOrder }) => `${supplierOrderNumber}#${positionInOrder}`);
